import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Unregister ONLY legacy/stale service workers (e.g. an old
// `/service-worker.js` kill-switch from a previous app migration). We must
// NOT unregister `/sw.js` — that is the real push-notification worker
// registered by NotificationSettings.jsx and PushNotificationContext.jsx.
// Unregistering it on every app load was the root cause of
// "no active Service Worker" errors when subscribing to push.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      const swUrl = (registration.active && registration.active.scriptURL) ||
                    (registration.installing && registration.installing.scriptURL) ||
                    (registration.waiting && registration.waiting.scriptURL) ||
                    '';
      // Keep /sw.js (the push worker). Unregister anything else, including
      // the legacy /service-worker.js stub.
      if (!swUrl.endsWith('/sw.js')) {
        registration.unregister();
      }
    });
  });
}

// Show diagnostic info
const diagEl = document.getElementById('qs-diag');
if (diagEl) diagEl.textContent = 'v20260407b bundle OK, mounting...';

try {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} catch (err) {
  // If React crashes synchronously during render setup
  const rootEl = document.getElementById("root");
  if (rootEl) {
    rootEl.innerHTML = '<div style="padding:24px;font-family:system-ui;color:#ef4444">' +
      '<h2>App crashed during startup</h2>' +
      '<pre style="white-space:pre-wrap;font-size:12px;color:#64748b">' + String(err) + '\n' + (err.stack || '') + '</pre>' +
      '<br><a href="/" style="color:#2563eb" onclick="localStorage.clear();sessionStorage.clear();return true">Retry</a></div>';
  }
}

// Catch unhandled promise rejections (React 18 async errors)
window.addEventListener('unhandledrejection', (event) => {
  const diagEl2 = document.getElementById('qs-diag');
  if (diagEl2) diagEl2.textContent = 'PROMISE ERROR: ' + String(event.reason);
  const rootEl = document.getElementById("root");
  const loader = rootEl && rootEl.querySelector('#initial-loader');
  if (loader) {
    loader.innerHTML = '<div style="padding:24px;font-family:system-ui;color:#ef4444;text-align:center">' +
      '<p>App error: ' + String(event.reason).substring(0, 200) + '</p>' +
      '<br><a href="/" style="color:#2563eb;text-decoration:underline" ' +
      'onclick="localStorage.clear();sessionStorage.clear();return true">Retry</a></div>';
  }
});
